.tooltip {
	padding: var(--jpo-common-base-spacing);
	text-align: center;
}

.tooltip > h4 {
	font-weight: var(--ds-font-weight-bold, bold);
	color: var(--ds-text-inverse, white);
}
